<div class="container my-4">
	<div class="d-flex flex-row align-items-center justify-content-between w-100 my-2 py-2">
		<input
			type="text"
			class="form-control w-75"
			(keyup)="refreshFilter($event)"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>

		<button mat-raised-button color="primary" (click)="addRooms()" [disabled]="editable">Dodaj pokój</button>
	</div>
	<div *ngIf="!service.data.rooms">
		<div class="alert alert-warning text-center">Brak pokoi! Dodaj je by wyświetlić listę pokoi dla produktu.</div>
	</div>
	<fieldset [disabled]="editable" *ngIf="service.data.rooms">
		<mat-table
			#dataTable
			*ngIf="matData"
			[dataSource]="matData"
			multiTemplateDataRows
			matSortDirection="desc"
			matSortActive="isActive"
			cdkDropList
			cdkDropListDisabled="true"
			matSort
		>
			<ng-container matColumnDef="lp">
				<mat-header-cell *matHeaderCellDef>LP</mat-header-cell>
				<mat-cell *matCellDef="let element; let i = dataIndex">{{ i + 1 }}</mat-cell>
			</ng-container>
			<ng-container matColumnDef="type">
				<mat-header-cell *matHeaderCellDef> Typ pokoju </mat-header-cell>

				<mat-cell *matCellDef="let element">{{ element.codeName }}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="name">
				<mat-header-cell *matHeaderCellDef> Dopłata za pokój za noc </mat-header-cell>
				<mat-cell *matCellDef="let element">{{ element.fee | price }}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="roomName">
				<mat-header-cell *matHeaderCellDef> Nazwa pokoju </mat-header-cell>
				<mat-cell *matCellDef="let element">{{ element.roomNumber }}</mat-cell>
			</ng-container>
			<ng-container matColumnDef="level">
				<mat-header-cell *matHeaderCellDef> Piętro </mat-header-cell>
				<mat-cell *matCellDef="let element">{{ element.level }}</mat-cell>
			</ng-container>
			<ng-container matColumnDef="view">
				<mat-header-cell *matHeaderCellDef> Widok </mat-header-cell>
				<mat-cell *matCellDef="let element">{{ getView(element.view) }}</mat-cell>
			</ng-container>
			<ng-container matColumnDef="description">
				<mat-header-cell *matHeaderCellDef> Opis </mat-header-cell>
				<mat-cell *matCellDef="let element"
					><i class="fa-solid fa-eye" [matTooltip]="element.description | convertComment"></i
				></mat-cell>
			</ng-container>
			<ng-container matColumnDef="conveniances">
				<mat-header-cell *matHeaderCellDef> Udogodnienia </mat-header-cell>
				<mat-cell *matCellDef="let element" class="d-flex"
					><ul>
						<li *ngFor="let item of element.conveniences">
							{{ getConveniences(item) }}
						</li>
					</ul>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="isActive">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Aktywny </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<i [ngClass]="[element.isActive ? 'fa-solid fa-check' : 'fa-solid fa-xmark']"></i
				></mat-cell>
			</ng-container>
			<ng-container matColumnDef="NoName">
				<mat-header-cell *matHeaderCellDef> No name </mat-header-cell>
				<mat-cell *matCellDef="let element"
					><i [ngClass]="[element.isNoName ? 'fa-solid fa-check' : 'fa-solid fa-xmark']"></i
				></mat-cell>
			</ng-container>
			<ng-container matColumnDef="edit">
				<mat-header-cell *matHeaderCellDef> Edytuj </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<button mat-raised-button color="primary" (click)="onEditClick(element)" [disabled]="editable">
						<i class="fa-solid fa-pen-to-square"></i>
						Edytuj
					</button>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="expand">
				<mat-header-cell *matHeaderCellDef> Rozwiń/Zwiń </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<button
						mat-icon-button
						aria-label="expand row"
						(click)="
							expandedElement = expandedElement === element ? null : element; $event.stopPropagation()
						"
					>
						<i
							[ngClass]="[
								expandedElement !== element ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down',
							]"
						></i>
					</button>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="expandedDetail">
				<mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
					<app-product-rooms-slave
						class="example-element-detail"
						[@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"
						[data]="element.roomSlaves"
						[getRoom]="element.roomNumber"
					></app-product-rooms-slave>
				</mat-cell>
			</ng-container>
			<mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></mat-header-row>
			<mat-row
				*matRowDef="let element; columns: columnsToDisplayWithExpand"
				class="example-element-row"
				[class.example-expanded-row]="expandedElement === element"
				(click)="expandedElement = expandedElement === element ? null : element"
				cdkDrag
			></mat-row>
			<mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></mat-row>
		</mat-table>
	</fieldset>
</div>
